import React, { type ReactNode } from 'react';
import Modal from '../Modal';
import Title from '../Title';
import Button from '../Button';

interface Props {
  title: string;
  content: ReactNode;
  buttonText?: string;
  isOpen?: boolean;
  hideCancel?: boolean;
  cancelText?: string;
  onConfirm: () => void;
  onRequestClose: () => void;
}

function ConfirmModal({
  title,
  content,
  buttonText = '确认操作',
  isOpen = false,
  hideCancel,
  cancelText,
  onConfirm,
  onRequestClose,
}: Props) {
  return (
    <Modal
      isOpen={isOpen}
      header={<Title>{title}</Title>}
      footer={<Button onClick={() => onConfirm()}>{buttonText}</Button>}
      hideCancel={hideCancel}
      cancelText={cancelText}
      onRequestClose={onRequestClose}
    >
      <div className="relative flex h-full flex-col items-center justify-center">
        {content}
      </div>
    </Modal>
  );
}

export default ConfirmModal;
